import React from 'react';
import Loadable from '@loadable/component';

import './mission-statement.styles.scss';

const Pulse = Loadable(() => import('react-reveal/Pulse'));

const MissionStatement: React.FC = () => {
  return (
    <Pulse>
      <div className="about ptb-100">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="about-image">
                <img
                  src={require('../../../assets/photos/who-we-are-banner.png')}
                  alt="banner"
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <div className="about-content">
                <div className="content">
                  <span className="sub-title">Who We Are</span>
                  <h2>Mission Statement</h2>
                  <p>
                    Hop In is building an ecosystem focused on improving the
                    worker lifestyle by providing a marketplace of innovative
                    solutions to the daily issues impacting the workforce.
                  </p>
                  <p>
                    Hop In moves people, <br /> Not just towards their
                    destination but towards a healthier, more productive and
                    fulfilling life. We do this through ambition, exemplary
                    leadership and innovation.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Pulse>
  );
};

export default MissionStatement;
